<template>
  <div class="col-md-12 servers_list">
    <div class="filter">
      <div class="info">
        {{this.translate('server.active')}}
      </div>
      <label class="switch" @click.prevent="checkbox = !checkbox">
        <input type="checkbox" v-model="active">
        <span class="slider round"></span>
      </label>
    </div>
    <div class="loading" v-if="loading">
      <div class="spinner">
        <scale-loader />
      </div>
    </div>
    <div class="row response_table" v-else>
      <table>
        <thead style="height: 50px; flex:0; display: inline-block">
          <tr>
            <th
              scope="col"
              style="width: 40px"
            >
              ID
            </th>
            <th scope="col">
              {{ translate('server.name') }}
            </th>
            <th scope="col">
              {{ translate('server.name_short') }}
            </th>
            <th scope="col">
              {{ translate('server.group') }}
            </th>
            <th scope="col">
              {{ translate('server.place') }}
            </th>
            <th scope="col">
              IP
            </th>
            <th scope="col">
              {{ translate('server.backup') }}
            </th>

            <th scope="col">
              {{ translate('server.devices') }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(server,key) in servers"
            :key="key"
            @click.prevent="upd_server(server)"
            class="server_item"
          >
            <td
              data-label="ID"
              style="width: 40px"
            >
              {{ server.id }}
            </td>
            <td :data-label="translate('server.name')">
              {{ server.name }}
            </td>
            <td :data-label="translate('server.name_short')">
              {{ server.name_short }}
            </td>
            <td :data-label="translate('server.group')">
              {{ get_group_server(server.server_group_id) }}
            </td>
            <td :data-label="translate('server.place')">
              {{ server.place }}
            </td>
            <td data-label="IP">
              <server-ports :server="server" />
            </td>
            <td :data-label="translate('server.backup')">
              {{ +server.backup === 1 ? (translate('ON') + ' ('+ translate('server.priority') + ': ' + server.backup_priority) + ')' : translate('OFF') }}
            </td>
            <td :data-label="translate('server.devices')">
              {{ server.device_count }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>

import ServerPorts from './ServerPorts'
import EditServer from './EditServer'

export default {
  name: 'ListServer',
  components: {
    ServerPorts
  },
  props: {
    active: Boolean,
    servers: Array,
    groups_servers: Array
  },
  data () {
    return {
      checkbox: false
    }
  },

  watch:{
    checkbox(){
      this.$emit('change_active', this.checkbox)
    }
  },
  computed:{
    loading(){
      return !(this.servers.length > 0)
    }
  },

  methods: {
    upd_server (val) {
      if (!this.$store.getters.getPermissions.permissionGod) return
      
      let t = this.$createElement(EditServer, {
        props: {
          server: val,
          groups_servers: this.groups_servers
        },
        on: {
          close: () => {
            this.$modal.hide('dynamic-modal')
          },
          update: (val) => {
            this.update(val)
          }
        }
      })

      let temp = {
        render () { return t }
      }

      this.$modal.show(temp, {}, {height: 'auto', name: 'dynamic-modal'})
    },
    update (val) {
      this.$http.v1.saveServer(val, () => {
        this.global_notify('info', this.translate('server.profile_save'))
        this.$emit('update_servers_list')
      })
    },
    get_group_server(group_id){
      for (let group of this.groups_servers){
        if (group.id === group_id){
          return group.name
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .servers_list{
    height: 100%;

    .filter{
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      min-height: 40px;
      height: 5%;

      .switch {
        position: relative;
        display: inline-block;
        width: 45px;
        height: 22px;
        margin-bottom: 0;
      }
      .switch input {
        display:none;
      }
      .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #ccc;
        -webkit-transition: .4s;
        transition: .4s;
      }

      .slider:before {
        position: absolute;
        content: "";
        height: 16px;
        width: 16px;
        left: 6px;
        bottom: 3px;
        background-color: white;
        -webkit-transition: .4s;
        transition: .4s;
      }

      input:checked + .slider {
        background-color: #41B883;
      }

      input:focus + .slider {
        box-shadow: 0 0 1px #41B883;
      }

      input:checked + .slider:before {
        transform: translateX(18px);
      }

      .slider.round {
        border-radius: 34px;
      }

      .slider.round:before {
        border-radius: 50%;
      }
    }

    .loading {
      background-color: #fff;
      height: 95%;
      width: calc(100% - 30px);
    }

    .response_table{
      height: 95%;
    }

    .server_item{
      cursor: pointer;
      &:hover{
        background-color: #eee;
      }
    }
  }

</style>
